import api from './';

export default {
  getProjectSubTasks() {
    return api.post('ProjectSubTasks/GetList', {}).then(response => response.data);
  },

  getProjectSubTask(arg) {
    return api.post('ProjectSubTasks/Get', { projectSubTaskGuid: arg }).then(response => response.data);
  },

  getListByProject(arg) {
    return api
      .post('ProjectSubTasks/GetListByProject', { projectGuid: arg })
      .then(response => response.data);
  },

  saveProjectSubTask(arg) {
    return api.post('ProjectSubTasks/Save', { projectSubTask: arg }).then(response => response.data);
  },

  searchProjectSubTask(arg) {
    return api.post('ProjectSubTasks/Search', { search: arg }).then(response => response.data);
  },

  deleteProjectSubTask(arg) {
    return api
      .post('ProjectSubTasks/Delete', { projectSubTaskGuid: arg })
      .then(response => response.data);
  },
};
